module.exports = __webpack_public_path__ + "static/smalltalksbanner-ae33f8661265c4e0a91155c0f6f3fa7d.png";